export function getGoogleMapsUrl(query) {
  const baseUrl = 'https://www.google.com/maps/search/';

  return `${baseUrl}?api=1&query=${encodeURIComponent(query)}`;
}

export function getAppleMapsUrl(query) {
  const baseUrl = 'https://maps.apple.com/';

  return `${baseUrl}?q=${encodeURIComponent(query)}`;
}

export function getGoogleMapsDirectionsUrl(query) {
  const baseUrl = 'https://www.google.com/maps/dir/';

  return `${baseUrl}?api=1&destination=${encodeURIComponent(query)}`;
}

export function getAppleMapsDirectionsUrl(query) {
  const baseUrl = 'https://maps.apple.com/';

  return `${baseUrl}?daddr=${encodeURIComponent(query)}&dirflg=d`;
}

export const getMapSearchLinkFactory = ({ location, mapProvider }) =>
  mapProvider === 'apple' ? getAppleMapsUrl(location) : getGoogleMapsUrl(location);

export const getMapDirectionsLinkFactory = ({ location, mapProvider }) =>
  mapProvider === 'apple' ? getAppleMapsDirectionsUrl(location) : getGoogleMapsDirectionsUrl(location);
